.GlassSurface {
    border-radius: var(--soniq-t--global--border--radius--primary--xl);
    transition: all ease-in .2s;

    a&,
    button& {
        cursor: pointer;
    }
}

.GlassSurface--alignCenter {
    display: flex;
    align-items: center;
    justify-content: center;
}

.glassSwatch--panel {
    background: var(--soniq-t--global--background--color--surface--panel);
    border: solid 1px var(--soniq-t--global--border--color--card--default);
    color: var(--soniq-t--global--text--color--hint--default);
}

.glassSwatch--card {
    background: var(--soniq-t--global--background--color--surface--card);
    border: solid 1px var(--soniq-t--global--border--color--card--default);
    color: var(--soniq-t--global--text--color--body--default);
}

.glassSwatch--input {
    background: var(--soniq-t--global--background--color--surface--input);
    border: solid 1px var(--soniq-t--global--border--color--card--default);
    color: var(--soniq-t--global--text--color--hint--default);
}

.glassSwatch--card,
.glassSwatch--input {
    &:hover {
        background: var(--soniq-t--global--background--color--surface--hover);
    }
}
